import { Validator } from 'vee-validate';
import printpologs from './printpologs/index.vue';
import printstickerlog from './printstickerlog/index.vue';
import pincodelog from './pincodelog/index.vue';
import partblog from './partblog/index.vue';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';

export default {
 name: 'printlogs',
 components: {
   'first': printpologs,
   'second': printstickerlog,
   'third': pincodelog,
   'fourth': partblog,
   VueElementLoading
 },
 props: [],
 data() {
   return {
     currentTab: 'First',
     componentKey:1,
     tabs: [
       { key:'First', value:'Print PO Log' },
       { key:'Second', value:'Print Sticker Log' },
       { key:'third', value:'Pincode Log' },
       { key:'fourth', value:'PartB Log' }
     ],
     useremail : '',
     isLoading: false,
     useremail : '',
   }
 },
 created:function() {
 },
 computed: {
   currentTabComponent: function () {
     this.componentKey += 1;
     return this.currentTab.toLowerCase()
   }
 },
 mounted() {
   var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
   var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
   var userdetail = JSON.parse(plaintext);
   this.useremail = userdetail.email;
 },
 methods: {
 }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/PrintingLog/PrintingLog.component.js